@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.customs-form-column {
  width: 100%;
  display: flex;
}

.icon-wrapper {
  height: 30px;
  width: 30px;
  min-width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    height: 18px;
    width: 18px;
    color: @columns--forms--fill-color;
  }
}

.text {
  width: 100%;
  font-size: 13px;

  > .customs-form-label,
  > button {
    .truncate();
    line-height: 30px;
  }
}

.print-button {
  font-size: 13px;
}
